var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9936 1.87576L20.2837 8.54231C20.5125 9.00598 20.9549 9.32726 21.4666 9.40149L28.8238 10.4706C30.1125 10.658 30.6267 12.2413 29.6945 13.1498L24.3709 18.3389C24.0009 18.6997 23.8318 19.22 23.9194 19.7293L25.1759 27.0567C25.3962 28.3399 24.049 29.3184 22.8965 28.7129L16.3164 25.2537C15.8588 25.0134 15.3118 25.0134 14.8542 25.2537L8.27406 28.7129C7.12159 29.319 5.7744 28.3399 5.99467 27.0567L7.25119 19.7293C7.33882 19.22 7.16966 18.6997 6.7997 18.3389L1.47607 13.1498C0.543875 12.2407 1.05804 10.6574 2.34681 10.4706L9.70399 9.40149C10.2157 9.32726 10.6581 9.00598 10.8869 8.54231L14.177 1.87576C14.7526 0.70808 16.4174 0.70808 16.9936 1.87576Z",
    fill: "url(#paint0_radial_7_37)",
    stroke: "url(#paint1_angular_7_37)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7_37",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.002 12.9558) rotate(132.769) scale(28.2298 30.6958)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB0413"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414597,
    stopColor: "#AE0049"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_7_37",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.8722 14.9485) rotate(-46.3668) scale(19.2719 20.7804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5D5D5",
    stopOpacity: 0.46
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.7a4413d96d2bcd1a20675ec407661e82.svg";
export { ForwardRef as ReactComponent };